import { z } from 'zod';
import { PAGINATION_PAGE_SIZE_LARGE } from '~/constants';

import { unique } from '@vestigas/utils';

import { zodCallOffStatusSchema } from '../validations';

// Call-off list item schema (used in list responses - simplified view)
export const zodCallOffListItemSchema = z.object({
  calloffNumber: z.string(),
  contractBuyerAssignedId: z.string().nullish(),
  contractId: z.uuid(),
  contractSellerAssignedId: z.string().nullish(),
  createdBy: z.string().nullish(),
  createdOn: z.iso.datetime({ offset: true }),
  deliveryDateFrom: z.iso.date().nullish(),
  deliveryDateUntil: z.iso.date().nullish(),
  deliverySiteId: z.uuid().nullish(),
  deliverySiteName: z.string().nullish(),
  deliveryTimeFrom: z.string().nullish(),
  deliveryTimeUntil: z.string().nullish(),
  id: z.uuid(),
  itemCount: z.number().int().nullish(),
  modifiedOn: z.iso.datetime({ offset: true }),
  sellerCompanyName: z.string().nullish(),
  status: zodCallOffStatusSchema,
});

// Query parameters schema for listing call-offs
export const zodCallOffsQueryParamsSchema = z.object({
  accountingReferenceIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((data) =>
      Array.isArray(data) ? unique(data).filter(Boolean).toSorted() : data,
    ),
  contractId: z.uuid().optional().catch(undefined),
  deliveryDateFrom: z.iso.date().optional().catch(undefined),
  deliveryDateUntil: z.iso.date().optional().catch(undefined),
  groupBy: z.string().optional().catch(undefined),
  limit: z.number().int().min(1).max(500).default(PAGINATION_PAGE_SIZE_LARGE),
  offset: z.number().int().min(0).default(0),
  page: z.coerce.number().int().nonnegative().optional().default(0).catch(0),
  searchString: z.string().trim().optional(),
  sellerId: z.uuid().optional().catch(undefined),
  siteIds: z
    .array(z.uuid())
    .optional()
    .catch(undefined)
    .transform((data) =>
      Array.isArray(data) ? unique(data).filter(Boolean).toSorted() : data,
    ),
  status: z
    .array(zodCallOffStatusSchema)
    .optional()
    .transform((statuses) => statuses?.toSorted())
    .catch(undefined),
  view: z.string().optional().catch(undefined),
});

// Paginated call-offs list response schema
export const zodCallOffsListResponseSchema = z.object({
  data: z.array(zodCallOffListItemSchema),
  hasNextPage: z.boolean(),
  paginatedCount: z.number().int().nonnegative(),
  totalCount: z.number().int().nonnegative().nullable(),
});
